/**
 * @generated SignedSource<<665198baf0f9c2c411158353f00d7520>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_Card_fieldSets$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly fields: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly fieldId?: string;
            readonly name?: string;
            readonly text?: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"footer_issueNavigator_FooterInternal">;
  readonly " $fragmentType": "main_issueNavigator_Card_fieldSets";
};
export type main_issueNavigator_Card_fieldSets$key = {
  readonly " $data"?: main_issueNavigator_Card_fieldSets$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Card_fieldSets">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_Card_fieldSets",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "footer_issueNavigator_FooterInternal"
    },
    {
      "concreteType": "JiraIssueFieldSetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fields",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "fieldId"
                            },
                            {
                              "kind": "ScalarField",
                              "name": "name"
                            },
                            {
                              "kind": "ScalarField",
                              "name": "text"
                            }
                          ],
                          "type": "JiraSingleLineTextField"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueFieldSetConnection"
};

(node as any).hash = "606cafbbef903d4ec28da2ea50226fe2";

export default node;
